export default __webpack_public_path__ + "static/media/iconSearch.b7d8f974.svg";